module.exports = __webpack_public_path__ + "media/bridge_reference1.2c7a95c0.mp3";